import React from 'react'
import '@/sass/contact.scss'
import { SendEmail } from 'util/email';

interface IState {
    text1: string,
    btnText: string
}

class Contact extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            text1: "Interest with my works or want to have collaboration? Let's grab some coffee and talk about it!",
            btnText: "Let's talk"
        }
    }

    render() {
        return (
            <div id="contact" className="contact">
                <div className="container">
                    <div className="row justify-content-center">
                        <h2 className="header col-12">Get in Touch</h2>
                        <div className="content-container col-12">
                        <span>{this.state.text1}</span>
                            <div className="btn-container">
                                <button onClick={SendEmail} className="btn btn-lg btn-custom">{this.state.btnText}</button>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default Contact